import { useState } from "react";
import styles from "./calculator.module.css";
import calculatorList from "../../helpers/calculatorList";
import MortgageRepayment from "./mortgageRepayment/mortgageRepayment";
import RefinanceCalculator from "./refinance/refinanceCalculator";
import BorrowingCapacity from "./borrowingCapacity/borrowingCapacity";

const Calculator = ({ selectedCalc }) => {
  // const [selectedCalc, setSelectedCalc] = useState(
  //   calculatorList.mortgageRepayment
  // );

  // const changeCalc = (selected) => {
  //   setSelectedCalc(selected);
  // };

  const getCalc = (calc) => {
    if (calc === calculatorList.mortgageRepayment) {
      return <MortgageRepayment />;
    }
    if (calc === calculatorList.refinance) {
      return <RefinanceCalculator />;
    }
    if (calc === calculatorList.borrowingCapacity) {
      return <BorrowingCapacity />;
    }
  };

  return (
    <>
      {/* <ul
        className={`nav nav-pills justify-content-center ${styles.tabs_wrapper}`}
      >
        <li className="nav-item">
          <button
            className={`nav-link ${
              selectedCalc === calculatorList.borrowingCapacity
                ? styles.bactive
                : styles.nactive
            }`}
            onClick={() => changeCalc(calculatorList.borrowingCapacity)}
          >
            Borrowing Capacity
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${
              selectedCalc === calculatorList.refinance
                ? styles.bactive
                : styles.nactive
            }`}
            onClick={() => changeCalc(calculatorList.refinance)}
          >
            Refinance Calculator
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${
              selectedCalc === calculatorList.mortgageRepayment
                ? styles.bactive
                : styles.nactive
            }`}
            onClick={() => changeCalc(calculatorList.mortgageRepayment)}
          >
            Mortgage Repayment
          </button>
        </li>
      </ul> */}
      <div>{getCalc(selectedCalc)}</div>
    </>
  );
};

export default Calculator;
